 
import React from 'react'
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Footer = () => {
 
  return (
    <footer className='pt-10 bg-dark'>
      <div className="container"> 
        <div className="flex flex-wrap md:justify-center mt-7">
          <div className="w-full lg:w-[30%] lg:pr-5">
            <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">About Ocelot</p>
            <p className="text-bc 2xl:pr-10 3xl:pr-14">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="w-full lg:w-[70%] lg:pl-5 mt-5 lg:mt-0">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Grow With Us</p> 
                <ul className="flex flex-col gap-2 list-none">
                  <li><Link to={"#"} className="text-bc hover:text-primary">Carriers</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Help</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Sell to Other Businesses</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Start Using Ocelot</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Report a Product</Link></li> 
                </ul>
              </div>
              <div>
                <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Important Link</p> 
                <ul className="flex flex-col gap-2 list-none">
                  <li><Link to={"#"} className="text-bc hover:text-primary">All categories</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Sell App On Ocelot</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Driver App On Ocelot</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Ocelot App</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Blogs</Link></li> 
                </ul>
              </div> 
              <div>
                <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Get to Know Us</p> 
                <ul className="flex flex-col gap-2 list-none">
                  <li><Link to={"#"} className="text-bc hover:text-primary">About Us</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Contact Us</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Business identity</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Terms and Conditions</Link></li>
                  <li><Link to={"#"} className="text-bc hover:text-primary">Privacy Notice and Cookies</Link></li> 
                </ul>
              </div> 
            </div>  
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10 md:mt-16">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Download customer app :</p>
                <div className="flex gap-2"> 
                  <Link to={"#"} className="inline-block">
                    <img src={"/images/icons/google-pay.svg"} width={130} height={39} alt="Google Play" />
                  </Link>
                  <Link to={"#"} className="inline-block">
                    <img src={"/images/icons/App_Store.svg"} width={130} height={39} alt="App Store" />
                  </Link>
                </div> 
              </div>
              <div>
                <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Download Seller app :</p>
                <div className="flex gap-2"> 
                  <Link to={"#"} className="inline-block">
                    <img src={"/images/icons/google-pay.svg"} width={130} height={39} alt="Google Play" />
                  </Link>
                  <Link to={"#"} className="inline-block">
                    <img src={"/images/icons/App_Store.svg"} width={130} height={39} alt="App Store" />
                  </Link>
                </div> 
              </div>
            </div>
          </div>
          
          <div>
            <div className="max-w-[300px] md:ml-auto">
              <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl mb-3 md:mb-4 lg:mb-5">Join Us : </p>
              <div className="flex gap-1">
                <Link to={`#`} target="_blank" className='text-white inline-block p-2 pl-0'><FaFacebookF className="sm:text-lg" /></Link>
                <Link to={`#`} target="_blank" className='text-white inline-block p-2'><FaTwitter className="sm:text-xl" /></Link>
                <Link to={`#`} target="_blank" className='text-white inline-block p-2'><FaLinkedinIn className="sm:text-xl" /></Link>
                <Link to={`#`} target="_blank" className='text-white inline-block p-2'><FaYoutube className="sm:text-xl" /></Link>
              </div> 
            </div>
          </div>
        </div>
        {/* grid */}

      </div>
     
      <div className="border-t border-[#747474] py-3 mt-8 md:mt-10"> 
        <div className="container">
          <p className="text-[#c4c4c4] text-center text-[11px] sm:text-[12px] md:text-[13px] lg:text-sm"></p>
          <p className="text-[#c4c4c4] text-center text-[11px] sm:text-[12px] md:text-[13px] lg:text-sm">Developed by 
            <a className="mx-1 text-primary" target="_blank" to="https://www.idiosystech.com/">IDIOSYS TECHNOLOGIES.</a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
